import { render, staticRenderFns } from "./NavInfoIcon.vue?vue&type=template&id=f5bcade2&scoped=true"
import script from "./NavInfoIcon.vue?vue&type=script&lang=js"
export * from "./NavInfoIcon.vue?vue&type=script&lang=js"
import style0 from "./NavInfoIcon.vue?vue&type=style&index=0&id=f5bcade2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5bcade2",
  null
  
)

export default component.exports